import { Skeleton } from "@/components/atoms/Skeleton";
import ApplicationRatingSkeleton from "@/components/molecules/ApplicationRating/applicationRatingSkeleton";
import { SINGLE_PAGE_SECTIONS } from "@/components/molecules/NavigationBarBySection";
import ReviewSkeleton from "@/components/molecules/Review/reviewSkeleton";

const AppRateAndReviewSkeleton = () => {
  return (
    <section id={SINGLE_PAGE_SECTIONS.ratings} className="max-sm:p-4">
      <div className="flex justify-between gap-3 items-center mb-5">
        <Skeleton className="w-40 h-10 rounded-xl" />
        <div className="flex gap-4">
          <Skeleton className="w-28 h-10 rounded-xl" />
          <Skeleton className="w-28 h-10 rounded-xl" />
        </div>
      </div>

      <div className="flex flex-row max-md:flex-col gap-10">
        <ApplicationRatingSkeleton />
        <div className="basis-3/4">
          <div className="flex flex-col gap-3">
            <ReviewSkeleton />
            <ReviewSkeleton />
            <ReviewSkeleton />
            <ReviewSkeleton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppRateAndReviewSkeleton;
